const PATH = 'path';
const SSO_SOURCE = 'ssosource';

export const SUPPORTED = [PATH, SSO_SOURCE];

export default {
  PATH,
  SSO_SOURCE,
};
